// extracted by mini-css-extract-plugin
export default {"tr":"DualHeaderTable_tr__w1Uwp","table_column":"DualHeaderTable_table_column__tO-tk","table_data":"DualHeaderTable_table_data__Xlm3v"};